// javascript pour Nominis
import Bloodhound from "./bloodhound.js";
// eslint-disable-next-line
import Dropdown from "bootstrap/js/dist/dropdown";
// eslint-disable-next-line
import Carousel from "bootstrap/js/dist/carousel";
// eslint-disable-next-line
import Button from "bootstrap/js/dist/button";
// eslint-disable-next-line
import Collapse from "bootstrap/js/dist/collapse";
// eslint-disable-next-line
import Modal from "bootstrap/js/dist/modal";
import "../scss/nominis.scss";
import Handlebars from "handlebars";
// eslint-disable-next-line
import $ from "jquery";

// lazy loading of images
const lazyImages = document.querySelectorAll("img[data-src]");

const lazyLoad = (target) => {
  const io = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const src = img.getAttribute("data-src");
        const srcset = img.getAttribute("data-srcset");

        // Set the src and srcset attributes to initiate image loading
        img.setAttribute("src", src);
        if (srcset) {
          img.setAttribute("srcset", srcset);
        }

        // Stop observing the image
        observer.unobserve(img);
      }
    });
  });

  io.observe(target);
};

lazyImages.forEach(lazyLoad);

// Filtre texte en temps réel sur les pages liste
const searchInput = document.getElementById('nm-search');
if (searchInput) {
  let searchTimer   = null;
  let savedItems    = null; // items SSR sauvegardés avant remplacement

  const cardList = document.getElementById('nm-card-list');
  const searchSentinel = document.getElementById('nm-sentinel');

  function renderItem(item) {
    const a = document.createElement('a');
    a.className = 'list-group-item list-group-item-action';
    a.href = item.url;
    a.textContent = item.nom;
    if (item.resume) {
      const small = document.createElement('small');
      small.className = 'text-muted d-block';
      small.innerHTML = item.resume;
      a.appendChild(small);
    }
    return a;
  }

  function restoreItems() {
    if (!cardList || savedItems === null) return;
    cardList.innerHTML = '';
    savedItems.forEach((el) => cardList.appendChild(el));
    savedItems = null;
    if (searchSentinel) searchSentinel.style.display = '';
  }

  searchInput.addEventListener('input', () => {
    const q = searchInput.value.trim();
    if (!cardList) return;
    clearTimeout(searchTimer);

    if (!q) {
      restoreItems();
      cardList.querySelectorAll('.list-group-item').forEach((el) => { el.style.display = ''; });
      return;
    }

    if (searchSentinel) {
      // Recherche serveur (liste paginée) — debounce 300 ms
      searchTimer = setTimeout(() => {
        if (savedItems === null) {
          savedItems = Array.from(cardList.querySelectorAll('.list-group-item'));
        }
        const params = new URLSearchParams({
          type:   searchSentinel.dataset.type,
          mode:   searchSentinel.dataset.mode,
          filtre: searchSentinel.dataset.filtre,
          search: q,
          offset: 0,
          limit:  200,
        });
        fetch('/api/liste.php?' + params)
          .then((r) => r.json())
          .then((items) => {
            cardList.innerHTML = '';
            searchSentinel.style.display = 'none';
            if (!Array.isArray(items) || !items.length) {
              const msg = document.createElement('p');
              msg.className = 'text-muted px-3 py-2 mb-0';
              msg.textContent = 'Aucun résultat';
              cardList.appendChild(msg);
              return;
            }
            items.forEach((item) => cardList.appendChild(renderItem(item)));
          });
      }, 300);
    } else {
      // Filtre local (liste complète déjà chargée)
      cardList.querySelectorAll('.list-group-item').forEach((el) => {
        el.style.display = el.textContent.toLowerCase().includes(q.toLowerCase()) ? '' : 'none';
      });
    }
  });
}

// Infinite scroll sur ls.php et lp.php
const sentinel = document.getElementById('nm-sentinel');
if (sentinel) {
  const cardList  = document.getElementById('nm-card-list');
  const loading   = document.getElementById('nm-loading');
  let offset      = parseInt(sentinel.dataset.offset, 10);
  let busy        = false;
  let hasMore     = true;

  const observer = new IntersectionObserver((entries) => {
    if (!entries[0].isIntersecting || busy || !hasMore) return;
    busy = true;
    loading.classList.remove('d-none');

    const params = new URLSearchParams({
      type:   sentinel.dataset.type,
      mode:   sentinel.dataset.mode,
      filtre: sentinel.dataset.filtre,
      offset: offset,
      limit:  50,
    });

    fetch('/api/liste.php?' + params)
      .then((r) => r.json())
      .then((items) => {
        if (!Array.isArray(items) || !items.length) { hasMore = false; sentinel.remove(); return; }
        items.forEach((item) => {
          const a = document.createElement('a');
          a.className = 'list-group-item list-group-item-action';
          a.href = item.url;
          a.textContent = item.nom;
          if (item.resume) {
            const resumeEl = document.createElement('small');
            resumeEl.className = 'text-muted d-block';
            resumeEl.innerHTML = item.resume;
            a.appendChild(resumeEl);
          }
          cardList.appendChild(a);
        });
        offset += items.length;
        if (items.length < 50) { hasMore = false; sentinel.remove(); }
      })
      .finally(() => { busy = false; loading.classList.add('d-none'); });
  }, { threshold: 0 });

  observer.observe(sentinel);
}

function mois(mth) {
  switch (mth) {
    case 1:
      return "Janvier";
    case 2:
      return "Fevrier";
    case 3:
      return "Mars";
    case 4:
      return "Avril";
    case 5:
      return "Mai";
    case 6:
      return "Juin";
    case 7:
      return "Juillet";
    case 8:
      return "Aout";
    case 9:
      return "Septembre";
    case 10:
      return "Octobre";
    case 11:
      return "Novembre";
    case 12:
      return "Decembre";
    default:
      return "mois";
  }
}

var rechercheSaint = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.whitespace,
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  remote: {
    url: "/pages/sg.php?type=saint&query=%QUERY",
    wildcard: "%QUERY",
  },
});
var recherchePrenom = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.whitespace,
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  remote: {
    url: "/pages/sg.php?type=prenom&query=%QUERY",
    wildcard: "%QUERY",
  },
});
var rechercheSite = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.whitespace,
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  remote: {
    url: "/pages/sg.php?type=site&query=%QUERY",
    wildcard: "%QUERY",
  },
});

$(function () {
  // Recherche unifiée — 3 datasets catégorisés
  $("#rechercheValeur")
    .typeahead(
      { hint: true, highlight: true, minLength: 1 },
      {
        name: "prenoms",
        displayKey: "prenom",
        source: recherchePrenom,
        limit: 5,
        templates: {
          header: '<div class="tt-category">Prénoms</div>',
          suggestion: Handlebars.compile("<div>{{prenom}}</div>"),
        },
      },
      {
        name: "saints",
        displayKey: "nom",
        source: rechercheSaint,
        limit: 5,
        templates: {
          header: '<div class="tt-category">Saints</div>',
          suggestion: Handlebars.compile("<div>{{nom}}</br><span class=small>{{resume}}</span></div>"),
        },
      },
      {
        name: "site",
        displayKey: "nom",
        source: rechercheSite,
        limit: 5,
        templates: {
          header: '<div class="tt-category">Sur le site</div>',
          suggestion: Handlebars.compile("<div>{{nom}}</br><span class=small>{{resume}}</span></div>"),
        },
      }
    )
    .on("typeahead:select", function (ev, selection) {
      window.location.href = selection.link;
    });
  $("#calendrier, #calendrier-mobile").on("change", function () {
    let selectDate = new Date($(this).val());
    if (selectDate.toString() != "Invalid Date") {
      let annee = selectDate.getFullYear();
      if (annee < 1000) annee = annee + 2000;
      window.location =
        "/contenus/fetes/" +
        selectDate.getDate() +
        "/" +
        (selectDate.getMonth() + 1) +
        "/" +
        annee +
        "/" +
        selectDate.getDate() +
        "-" +
        mois(selectDate.getMonth() + 1) +
        "-" +
        annee +
        ".html";
    } else {
      console.log("Date incorrecte");
    }
  });
  if (page == "jour") {
    var start = null;
    window.addEventListener("touchstart", function (event) {
      if (event.touches.length === 1) {
        start = event.touches.item(0).clientX;
      } else {
        start = null;
      }
    });
    window.addEventListener("touchend", function (event) {
      var offset = 100;
      var selectDate;
      var annee;
      if (start) {
        var end = event.changedTouches.item(0).clientX;
        if (end > start + offset) {
          selectDate = new Date($("#calendrier").val());
          if (selectDate.toString() != "Invalid Date") {
            selectDate.setDate(selectDate.getDate() - 1);
            annee = selectDate.getFullYear();
            if (annee < 1000) annee = annee + 2000;
            window.location =
              "/contenus/fetes/" +
              selectDate.getDate() +
              "/" +
              (selectDate.getMonth() + 1) +
              "/" +
              annee +
              "/" +
              selectDate.getDate() +
              "-" +
              mois(selectDate.getMonth() + 1) +
              "-" +
              annee +
              ".html";
          }
        }
        if (end < start - offset) {
          selectDate = new Date($("#calendrier").val());
          if (selectDate.toString() != "Invalid Date") {
            selectDate.setDate(selectDate.getDate() + 1);
            annee = selectDate.getFullYear();
            if (annee < 1000) annee = annee + 2000;
            window.location =
              "/contenus/fetes/" +
              selectDate.getDate() +
              "/" +
              (selectDate.getMonth() + 1) +
              "/" +
              annee +
              "/" +
              selectDate.getDate() +
              "-" +
              mois(selectDate.getMonth() + 1) +
              "-" +
              annee +
              ".html";
          }
        }
      }
    });
  }
  if (page == "st") {
    $("#abonnement").submit(function (event) {
      event.preventDefault();
      try {
        grecaptcha.ready(function () {
          grecaptcha
            .execute("6Le_3UUiAAAAAGA6GGbb2mQ6zAQKbO2Lpe2f9rOM", {
              action: "abonnement",
            })
            .then(function (token) {
              $("#abonnement").prepend(
                '<input type="hidden" name="token" value="' + token + '">'
              );
              $("#abonnement").prepend(
                '<input type="hidden" name="action" value="abonnement">'
              );
              $("#abonnement").unbind("submit").submit();
            });
        });
      } catch (e) {
        alert("Merci d'autoriser les cookies");
      }
    });
  }
  if (page == "st" || page == "pn") {
    $("#suggestion").submit(function (event) {
      event.preventDefault();
      try {
        grecaptcha.ready(function () {
          grecaptcha
            .execute("6Le_3UUiAAAAAGA6GGbb2mQ6zAQKbO2Lpe2f9rOM", {
              action: "suggestion",
            })
            .then(function (token) {
              $("#suggestion").prepend(
                '<input type="hidden" name="token" value="' + token + '">'
              );
              $("#suggestion").prepend(
                '<input type="hidden" name="action" value="suggestion">'
              );
              $("#suggestion").unbind("submit").submit();
            });
        });
      } catch (e) {
        alert("Merci d'autoriser les cookies");
      }
    });
    $("#ajout-form").submit(function (event) {
      event.preventDefault();
      try {
        grecaptcha.ready(function () {
          grecaptcha
            .execute("6Le_3UUiAAAAAGA6GGbb2mQ6zAQKbO2Lpe2f9rOM", {
              action: "ajout",
            })
            .then(function (token) {
              $("#ajout-form").prepend(
                '<input type="hidden" name="token" value="' + token + '">'
              );
              $("#ajout-form").prepend(
                '<input type="hidden" name="action" value="ajout">'
              );
              $("#ajout-form").unbind("submit").submit();
            });
        });
      } catch (e) {
        alert("Merci d'autoriser les cookies");
      }
    });
  }
});
